// extracted by mini-css-extract-plugin
export default {"imageWrapper":"yM-z","twoColumnImage":"zM-z"};